const WarningTriangle = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.6379 3.52486L2.3719 12.7135C1.83457 13.6509 2.51124 14.8182 3.59124 14.8182H14.1232C15.2032 14.8182 15.8799 13.6509 15.3426 12.7135L10.0766 3.52486C9.53657 2.58286 8.1779 2.58286 7.6379 3.52486Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.85645 9.48503V6.81836"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="8.856" cy="11.984" r="0.75" fill="currentColor" />
    </svg>
  )
}

export default WarningTriangle
